import { printReport } from './printUtils';

export const calculateStatistics = (vList, aList, mList, cList, todayStr, setStats) => {
  const nowObj = new Date();
  const threeMonthsLater = new Date();
  threeMonthsLater.setMonth(nowObj.getMonth() + 3);

  let expiringSoon = 0;
  let expired = 0;
  let active = 0;

  vList.forEach(v => {
    if (!v.warrantyExpiry || v.warrantyExpiry.includes('NaN') || v.warrantyExpiry === '-') {
      expired++;
      return;
    }
    const expDate = new Date(v.warrantyExpiry);
    if (expDate < nowObj) {
      expired++;
    } else if (expDate >= nowObj && expDate <= threeMonthsLater) {
      expiringSoon++;
    } else {
      active++;
    }
  });

  const modelData = mList.map(m => {
    const count = vList.filter(v => v.modelName === m.modelName).length;
    return {
      name: m.modelName,
      count,
      percentage: vList.length ? Math.round((count / vList.length) * 100) : 0
    };
  }).sort((a, b) => b.count - a.count);

  let totalAmount = 0;
  let todayAmount = 0;
  let receiptCount = 0;
  let completedCount = 0;
  let progressingCount = 0;
  let pendingCount = 0;
  let freeCount = 0;
  let paidCount = 0;
  const symptomMap = {};

  aList.forEach(a => {
    const amtWithVat = Number(a.totalCost || a.totalAmount || a.totalPrice || 0) + (Number(a.discount) || 0); // 할인 전 총액 기준으로 공급가 보정
    const amt = Math.round(amtWithVat / 1.1);
    
    const status = a.status || '접수';
    const date = a.settleDate || a.asDate || '';

    // 🚀 [핵심 교정] 대시보드와 동일하게 '완료' 처리된 건만 매출(순수 공급가)로 인정하여 합산!
    if (status === '완료') {
      totalAmount += amt;
    }

    if (date === todayStr && (status === '완료' || status === '진행중')) {
      todayAmount += amt;
    }

    if (status === '완료') completedCount++;
    else if (status === '진행중') progressingCount++;
    else if (status === '보류') pendingCount++;
    else receiptCount++;

    const rType = a.repairType || '유상';
    if (rType === '무상' || amt === 0) {
      freeCount++;
    } else {
      paidCount++;
    }

    const symptom = a.symptom || '일반 정비/점검';
    const cleanSymptom = symptom.split('\n')[0].trim().substring(0, 18);
    if (cleanSymptom) {
      symptomMap[cleanSymptom] = (symptomMap[cleanSymptom] || 0) + 1;
    }
  });

  const topSymptoms = Object.keys(symptomMap).map(name => ({
    name,
    count: symptomMap[name],
    percentage: aList.length ? Math.round((symptomMap[name] / aList.length) * 100) : 0
  })).sort((a, b) => b.count - a.count).slice(0, 5);

  setStats({
    totalVehicles: vList.length,
    totalCustomers: cList.length, 
    totalAsAmount: totalAmount, // 오직 완료된 건의 100% 공급가 누적액
    todayAsAmount: todayAmount,   
    modelData,
    warrantyData: { expiringSoon, expired, active },
    asStatus: { receipt: receiptCount, completed: completedCount, progressing: progressingCount, pending: pendingCount },
    asType: { free: freeCount, paid: paidCount },
    topSymptoms
  });
};

export const handlePrintSales = (salesPeriod, targetDate, periodDetailList, periodTotalSales) => {
  const title = `경영 매출 상세 내역서 (${salesPeriod} 기준)`;
  const headers = ["정산완료일", "고객/차량번호", "담당정비사", "부품매출(공급가)", "공임매출(공급가)", "총합계(공급가)"];
  
  const rows = periodDetailList.map(r => {
    let pSales = 0; let lSales = 0;
    if (r.parts) {
      r.parts.forEach(p => { 
        pSales += (Number(p.price) || 0) * (Number(p.qty) || 0); 
        lSales += (Number(p.labor) || 0); 
      });
    }
    const totalExVat = r.costExVat || Math.round(((Number(r.totalCost) || 0) + (Number(r.discount) || 0)) / 1.1);
    return [
      r.settleDate || r.asDate,
      `${r.customerName} (${r.carNumber})`,
      r.mechanic, 
      `₩ ${pSales.toLocaleString()}`, 
      `₩ ${lSales.toLocaleString()}`, 
      `₩ ${totalExVat.toLocaleString()}`
    ];
  });

  printReport(title, headers, rows, { "조회 기간": salesPeriod, "조회 기준일": targetDate, "총 매출액(공급가)": `₩ ${periodTotalSales.toLocaleString()} 원` });
};

export const handleDownloadSalesExcel = (periodDetailList, targetDate) => {
  if (periodDetailList.length === 0) return alert("다운로드할 매출 내역이 없습니다.");
  const headers = ["날짜", "고객명", "차량번호", "정비사", "부품매출(공급가)", "공임매출(공급가)", "총합계(공급가)"];
  
  const rows = periodDetailList.map(r => {
    let pSales = 0; let lSales = 0;
    if (r.parts) {
      r.parts.forEach(p => { 
        pSales += (Number(p.price) || 0) * (Number(p.qty) || 0); 
        lSales += (Number(p.labor) || 0); 
      });
    }
    const totalExVat = r.costExVat || Math.round(((Number(r.totalCost) || 0) + (Number(r.discount) || 0)) / 1.1);
    return [
      `"${r.settleDate || r.asDate}"`,
      `"${r.customerName}"`, 
      `"${r.carNumber}"`, 
      `"${r.mechanic}"`, 
      pSales, 
      lSales, 
      totalExVat
    ];
  });

  const csvContent = "\uFEFF" + [headers.join(","), ...rows.map(e => e.join(","))].join("\n");
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.setAttribute("href", url); link.setAttribute("download", `매출_상세_내역_공급가기준_${targetDate}.csv`);
  document.body.appendChild(link); link.click(); document.body.removeChild(link);
};

export const handlePrintUsedParts = (usedPartsDate, usedPartsModelFilter, usedPartsSearch, periodTotalUsedQty, periodTotalUsedCost, aggregatedPartsRanking) => {
  const title = `수요 예측을 위한 부품 소진 랭킹 및 재고 현황 리포트`;
  const headers = ["소진 순위", "차종(모델)", "부품명", "총 소진량", "현재고 상태", "누적 소진 원가(공급)"];
  const rows = aggregatedPartsRanking.map((p, idx) => [
    `${idx + 1} 위`, p.modelName, p.partName, `${p.totalQty} EA`, `${p.currentStock} EA`, `₩ ${p.totalCost.toLocaleString()}`
  ]);
  printReport(title, headers, rows, { "분석 조건일": usedPartsDate, "적용 필터": `차종: ${usedPartsModelFilter} / 검색: ${usedPartsSearch || '없음'}`, "총 소진 집계량": `${periodTotalUsedQty} EA`, "총 원가 합계": `₩ ${periodTotalUsedCost.toLocaleString()} 원` });
};

export const handleDownloadUsedPartsExcel = (aggregatedPartsRanking, usedPartsDate) => {
  if (aggregatedPartsRanking.length === 0) return alert("다운로드할 분석 데이터가 없습니다.");
  const headers = ["순위", "차종모델", "부품명", "총_소진량", "현재고_수량", "누적_소진원가"];
  const rows = aggregatedPartsRanking.map((p, idx) => [`${idx + 1}`, `"${p.modelName}"`, `"${p.partName}"`, p.totalQty, p.currentStock, p.totalCost]);
  const csvContent = "\uFEFF" + [headers.join(","), ...rows.map(e => e.join(","))].join("\n");
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.setAttribute("href", url); link.setAttribute("download", `부품_수요예측_랭킹분석_${usedPartsDate}.csv`);
  document.body.appendChild(link); link.click(); document.body.removeChild(link);
};

export const handlePrintStockParts = (selectedModel, filteredParts, filteredTotalValue) => {
  const title = `현재 부품 재고 및 자산 현황 보고서 (${selectedModel})`;
  const headers = ["차종 모델", "부품 고유코드 / 부품명", "보유 재고량", "재고 평가액 (원가기준)"];
  const rows = filteredParts.map(p => [p.modelName || '공용', `${p.partNo} / ${p.partName}`, `${p.currentStock} EA`, `₩ ${p.value.toLocaleString()}`]);
  printReport(title, headers, rows, { "필터 차종": selectedModel, "선택 차종 자산 총액": `₩ ${filteredTotalValue.toLocaleString()} 원` });
};

export const handleDownloadStockPartsExcel = (filteredParts) => {
  const headers = ["모델", "부품명", "부품코드", "현재고", "재고평가액"];
  const rows = filteredParts.map(p => [`"${p.modelName || '공용'}"`, `"${p.partName}"`, `"${p.partNo}"`, p.currentStock, p.value]);
  const csvContent = "\uFEFF" + [headers.join(","), ...rows.map(e => e.join(","))].join("\n");
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.setAttribute("href", url); link.setAttribute("download", `부품_자산_현황_${new Date().toISOString().split('T')[0]}.csv`);
  document.body.appendChild(link); link.click(); document.body.removeChild(link);
};

export const handlePrintWarrantyReport = (type, vehicles, todayStr) => {
  const nowObj = new Date();
  const threeMonthsLater = new Date();
  threeMonthsLater.setMonth(nowObj.getMonth() + 3);

  const filteredVehicles = vehicles.filter(v => {
    if (!v.warrantyExpiry || v.warrantyExpiry === '-' || v.warrantyExpiry.includes('NaN')) {
      return type === 'expired';
    }
    const expDate = new Date(v.warrantyExpiry);
    if (expDate < nowObj) {
      return type === 'expired';
    } else if (expDate >= nowObj && expDate <= threeMonthsLater) {
      return type === 'expiring';
    } else {
      return type === 'active';
    }
  });

  let typeTitle = ""; let scopeText = "";
  if (type === 'expiring') {
    typeTitle = "3개월 이내 보증만료 도래 차량 명단"; scopeText = "향후 3개월 이내 만료 도래 대상";
  } else if (type === 'expired') {
    typeTitle = "보증기간 최종 만료 차량 명단 (유상 전환 대상)"; scopeText = "보증기간 최종 만료 완료 차량";
  } else {
    typeTitle = "보증기간 안정권 운행 차량 명단"; scopeText = "보증 기한 넉넉한 정상 운행 대상";
  }

  const title = `이투빌리티 ${typeTitle}`;
  const headers = ["차량번호", "모델명", "차대번호(VIN)", "출고(인도)일", "보증만료일", "연계 소유주명"];
  const rows = filteredVehicles.map(v => [v.carNumber || '', v.modelName || '', v.vin || '', v.deliveryDate || '-', v.warrantyExpiry || '-', v.customerName || v.ownerName || '개인/법인 미지정']);
  printReport(title, headers, rows, { "모니터링 기준일": todayStr, "분류 구분": scopeText, "대상 차량 수": `${filteredVehicles.length} 대` });
};

export const handlePrintReport = (stats, asRecords, customers, periodTotalSales, salesPeriod, partsValue, usedPartsPeriod, periodTotalUsedQty, periodTotalUsedCost, filteredTotalValue, selectedModel, todayStr, monthlySalesTrend) => {
  const printWindow = window.open('', '_blank');
  if (!printWindow) {
    alert("팝업 차단이 설정되어 있습니다. 브라우저에서 팝업을 허용해주세요.");
    return;
  }

  const maxTotalSale = Math.max(...monthlySalesTrend.map(m => m.total), 1);
  const graphHtml = monthlySalesTrend.map(data => {
    const hTotal = maxTotalSale > 0 ? (data.total / maxTotalSale) * 100 : 0;
    const hParts = maxTotalSale > 0 ? (data.parts / maxTotalSale) * 100 : 0;
    const hLabor = maxTotalSale > 0 ? (data.labor / maxTotalSale) * 100 : 0;
    
    return `
      <div style="display: flex; flex-direction: column; align-items: center; width: 7%;">
        <div style="display: flex; align-items: flex-end; height: 140px; gap: 3px; width: 100%; justify-content: center;">
          <div style="width: 28%; height: ${hTotal}%; background: #10b981; border-radius: 4px 4px 0 0; min-height: 4px;"></div>
          <div style="width: 28%; height: ${hParts}%; background: #0ea5e9; border-radius: 4px 4px 0 0; min-height: 4px;"></div>
          <div style="width: 28%; height: ${hLabor}%; background: #8b5cf6; border-radius: 4px 4px 0 0; min-height: 4px;"></div>
        </div>
        <span style="font-size: 10px; color: #64748b; margin-top: 8px; font-weight: bold;">${data.month.split('-')[1]}월</span>
      </div>
    `;
  }).join('');

  const currentMonthData = monthlySalesTrend.length > 0 ? monthlySalesTrend[monthlySalesTrend.length - 1] : { month: '당월', total: 0, parts: 0, labor: 0 };
  const partsRatio = currentMonthData.total > 0 ? Math.round((currentMonthData.parts / currentMonthData.total) * 100) : 0;
  const laborRatio = currentMonthData.total > 0 ? Math.round((currentMonthData.labor / currentMonthData.total) * 100) : 0;
  const currentMonthStr = currentMonthData.month.includes('-') ? currentMonthData.month.split('-')[1] + '월' : '당월';

  const totalSupplyAmount = stats.totalAsAmount;

  const html = `
    <!DOCTYPE html>
    <html>
    <head>
      <title>EB-CRM 경영 정보 종합 성과 분석 보고서</title>
      <style>
        @page { size: A4 portrait; margin: 10mm 15mm; }
        body { font-family: 'Malgun Gothic', 'Apple SD Gothic Neo', sans-serif; padding: 0; margin: 0; color: #1e293b; -webkit-print-color-adjust: exact !important; print-color-adjust: exact !important; }
        .header { text-align: center; border-bottom: 2px solid #1e293b; padding-bottom: 10px; margin-bottom: 15px; }
        .header h1 { margin: 0; font-size: 20px; color: #0f172a; }
        .header p { margin: 6px 0 0 0; color: #64748b; font-size: 11px; }
        .grid { display: flex; gap: 10px; margin-bottom: 15px; }
        .kpi { flex: 1; padding: 12px; border-radius: 8px; color: white; text-align: left; }
        .kpi-title { font-size: 11px; opacity: 0.9; margin-bottom: 8px; font-weight: bold; line-height: 1.4; letter-spacing: -0.3px; word-break: keep-all; }
        .kpi-subtitle { font-size: 8.5px; font-weight: normal; opacity: 0.7; }
        .kpi-value { font-size: 16px; font-weight: bold; }
        .section-title { font-size: 13px; margin-bottom: 8px; border-left: 4px solid #3b82f6; padding-left: 8px; font-weight: bold; }
        .graph-container { background: #f8fafc; padding: 12px 20px; border-radius: 10px; border: 1px solid #e2e8f0; margin-bottom: 15px; }
        .graph-legend { display: flex; justify-content: flex-end; gap: 12px; font-size: 10px; font-weight: bold; margin-bottom: 10px; }
        .graph-bars { display: flex; height: 165px; align-items: flex-end; justify-content: space-between; padding: 5px 0; border-bottom: 1px solid #cbd5e1; }
        .table { width: 100%; border-collapse: collapse; margin-bottom: 10px; }
        .table th, .table td { border: 1px solid #cbd5e1; padding: 6px 8px; text-align: left; font-size: 10px; }
        .table th { background: #f1f5f9; color: #475569; }
        .footer-note { text-align: center; color: #94a3b8; font-size: 9px; margin-top: 10px; }
      </style>
    </head>
    <body>
      <div class="header">
        <h1>📊 EB-CRM 경영 정보 종합 성과 분석 보고서</h1>
        <p>출력 일시: ${new Date().toLocaleString()} | 시스템: EB-CRM Enterprise Core V8.5</p>
      </div>

      <div class="section-title">주요 경영 지표 (KPI)</div>
      <div class="grid">
        <div class="kpi" style="background: #1e293b;">
          <div class="kpi-title">전체 누적 매출 총액<br/><span class="kpi-subtitle">(순수 공급가 기준)</span></div>
          <div class="kpi-value">₩ ${totalSupplyAmount.toLocaleString()}</div>
        </div>
        <div class="kpi" style="background: #10b981;">
          <div class="kpi-title">부품 자산 총 평가액<br/><span class="kpi-subtitle">(매입 원가 기준)</span></div>
          <div class="kpi-value">₩ ${partsValue.total.toLocaleString()}</div>
        </div>
        <div class="kpi" style="background: #3b82f6;">
          <div class="kpi-title">총 AS 정비 처리 건수<br/><span class="kpi-subtitle">(시스템 전체 누적)</span></div>
          <div class="kpi-value">${asRecords.length} 건</div>
        </div>
        <div class="kpi" style="background: #8b5cf6;">
          <div class="kpi-title">CRM 유효 등록 고객<br/><span class="kpi-subtitle">(활성 계정 데이터)</span></div>
          <div class="kpi-value">${customers.length} 명</div>
        </div>
      </div>

      <div class="section-title">📈 최근 12개월 매출 추이 시각화 (공급가 기준)</div>
      <div class="graph-container">
        <div class="graph-legend">
          <span style="color: #10b981;">■ 총 합계</span>
          <span style="color: #0ea5e9;">■ 부품 매출</span>
          <span style="color: #8b5cf6;">■ 공임 매출</span>
        </div>
        <div class="graph-bars">
          ${graphHtml}
        </div>
      </div>

      <div class="section-title">📅 당월(${currentMonthStr}) 매출 세부 분석 (공급가 기준)</div>
      <div class="grid" style="margin-bottom: 15px;">
        <div class="kpi" style="background: #f8fafc; border: 1px solid #e2e8f0; color: #1e293b;">
          <div class="kpi-title" style="color: #64748b;">당월 총 매출 합계</div>
          <div class="kpi-value" style="color: #10b981;">₩ ${currentMonthData.total.toLocaleString()}</div>
        </div>
        <div class="kpi" style="background: #f8fafc; border: 1px solid #e2e8f0; color: #1e293b;">
          <div class="kpi-title" style="color: #64748b;">당월 부품 매출 (수익 비중)</div>
          <div class="kpi-value" style="color: #0ea5e9;">₩ ${currentMonthData.parts.toLocaleString()} <span style="font-size:11px; color:#94a3b8;">(${partsRatio}%)</span></div>
        </div>
        <div class="kpi" style="background: #f8fafc; border: 1px solid #e2e8f0; color: #1e293b;">
          <div class="kpi-title" style="color: #64748b;">당월 정비/공임 매출 (수익 비중)</div>
          <div class="kpi-value" style="color: #8b5cf6;">₩ ${currentMonthData.labor.toLocaleString()} <span style="font-size:11px; color:#94a3b8;">(${laborRatio}%)</span></div>
        </div>
      </div>

      <div class="section-title">상세 경영 요약 분석</div>
      <table class="table">
        <thead>
          <tr>
            <th>분석 모듈 구분</th>
            <th>비즈니스 운영 상태 / 요약 정보</th>
            <th>세부 핵심 지표 및 스크리닝 결과</th>
          </tr>
        </thead>
        <tbody>
          <tr><td>매출 분석 부문</td><td>전체 누적 결제 총액 (공급가)</td><td>누적 매출 공급가 총액: ₩ ${totalSupplyAmount.toLocaleString()} 원</td></tr>
          <tr><td>매출 분석 부문</td><td>TODAY 라이브 매출액 (공급가)</td><td>금일 실시간 마감 정산액: ₩ ${stats.todayAsAmount.toLocaleString()} 원</td></tr>
          <tr><td>매출 분석 부문</td><td>선택 기준 마감 매출액 (공급가)</td><td>선택 기간 총 매출액: ₩ ${periodTotalSales.toLocaleString()} 원</td></tr>
          <tr><td>부품 자산 부문</td><td>${usedPartsPeriod} 소진량 트래킹</td><td>선택 기간 부품 출고 소진량: ${periodTotalUsedQty} EA</td></tr>
          <tr><td>부품 자산 부문</td><td>출고 부품 누적 소진 원가</td><td>선택 기간 누적 소진원가: ₩ ${periodTotalUsedCost.toLocaleString()} 원</td></tr>
          <tr><td>AS 정비 부문</td><td>프로세스 완결 지표</td><td>최종 수납 마감 완료 상태: ${stats.asStatus.completed} 건</td></tr>
          <tr><td>보증 만료 예측</td><td>🚨 선제적 비포서비스 대상</td><td>3개월 이내 보증만료 도래: ${stats.warrantyData.expiringSoon} 대</td></tr>
          <tr><td>보증 만료 예측</td><td>유상 수리 적극 전환 대상</td><td>보증 기한 최종 만료: ${stats.warrantyData.expired} 대</td></tr>
        </tbody>
      </table>
      <div class="footer-note">
        본 리포트는 EB-CRM 시스템에 의해 실시간 데이터 기반으로 자동 생성되었습니다.
      </div>
    </body>
    </html>
  `;

  printWindow.document.open();
  printWindow.document.write(html);
  printWindow.document.close();

  setTimeout(() => { printWindow.print(); }, 500);
};